import type * as Api from 'Api'

export const serviceErrorHandbook: Api.ErrorsHandbook<'default'> = {
  default: [],
}
